import { c as _defineProperty } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-skeleton-1-6-0{display:block;width:100%;height:15px;margin-bottom:7px;border-radius:5px;background:#e1e1e1;content:\"\"}.hcr-skeleton--w-xs-1-6-0{width:25%}.hcr-skeleton--w-sm-1-6-0{width:33%}.hcr-skeleton--w-md-1-6-0{width:50%}.hcr-skeleton--w-lg-1-6-0{width:75%}.hcr-skeleton--h-xs-1-6-0{height:1px;margin-bottom:12px}.hcr-skeleton--h-md-1-6-0{height:26px;margin-bottom:12px}.hcr-skeleton--h-lg-1-6-0{height:44px;margin-bottom:12px}@media (min-width:1200px){.hcr-skeleton--h-lg-1-6-0{height:36px}}.hcr-skeleton--flush-bottom-1-6-0{margin-bottom:0}",
map:{"hcr-skeleton":"hcr-skeleton-1-6-0","hcr-skeleton--w-xs":"hcr-skeleton--w-xs-1-6-0","hcr-skeleton--w-sm":"hcr-skeleton--w-sm-1-6-0","hcr-skeleton--w-md":"hcr-skeleton--w-md-1-6-0","hcr-skeleton--w-lg":"hcr-skeleton--w-lg-1-6-0","hcr-skeleton--h-xs":"hcr-skeleton--h-xs-1-6-0","hcr-skeleton--h-md":"hcr-skeleton--h-md-1-6-0","hcr-skeleton--h-lg":"hcr-skeleton--h-lg-1-6-0","hcr-skeleton--flush-bottom":"hcr-skeleton--flush-bottom-1-6-0"}};

var bem = Bem('skeleton', styles);
var Skeleton = function Skeleton(_ref) {
  var _bem$b;

  var width = _ref.width,
      height = _ref.height,
      flushBottom = _ref.flushBottom,
      extraClasses = _ref.extraClasses,
      Elem = _ref.Elem;
  return React.createElement(Elem, {
    className: bem.b((_bem$b = {}, _defineProperty(_bem$b, "w-".concat(width), typeof width === 'string'), _defineProperty(_bem$b, "h-".concat(height), typeof height === 'string'), _defineProperty(_bem$b, 'flush-bottom', flushBottom === true), _bem$b), extraClasses)
  });
};
Skeleton.displayName = 'Skeleton';
Skeleton.defaultProps = {
  Elem: 'span',
  extraClasses: '',
  width: null,
  height: null,
  flushBottom: false
};
Skeleton.propTypes = {
  /** Override default html element */
  Elem: PropTypes.string,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Width of the skeleton */
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /** Height of the skeleton */
  height: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /** Removes bottom margin from the skeleton */
  flushBottom: PropTypes.bool
};
var skeleton = Injecss(Skeleton, styles);

export { skeleton as Skeleton };
